export default "__VITE_ASSET__dc91c399__"